module.exports = __webpack_public_path__ + "b2989c7e3f599cfd19c5cbad6d5e6f76.MP3";